import React from 'react';
import { useState } from 'react';
import { API_URL } from '../config/API_URLS.tsx';
import { authenticatedFetch } from "../auth/RequestSigner.tsx";
import ErrorModal from './ErrorModal.tsx';




function ShowStatusButton( {documento} ) {
    const [showMessage, setShowMessage] = useState(false);
    const [state, setState] = useState("");
    const [errorModalOpen, setErrorModalOpen] = useState(false);
    const [modalMessage, setModalMessage] = useState("");

    const handleClick =  async () => {  
        try {
            const response = await authenticatedFetch(`${API_URL}/v1/aprendiz-status/${documento}`, {
              method: 'get',          
              headers: {
                'Content-Type': 'application/json'
              }                
            });
            const data = await response.json();
            if (!response.ok) {
              throw new Error(data.detail || 'Error en la solicitud');
            }
            setState(data);
            setShowMessage(true);
        } catch (error) {
            console.error('Error:', error);
            setErrorModalOpen(true);
            setModalMessage(error.message || 'Error al verificar el estado');
        }
    };


    const handleClose = () => {
      setShowMessage(false);
    };

    const botonDeshabilitado = documento === '';


    return (
      <div data-testid="show-status-button-container">
        <button
            onClick={handleClick}
            disabled={botonDeshabilitado}        
            className={`w-full relative overflow-hidden group flex justify-center py-2 px-4 border border-transparent rounded-md shadow-sm text-sm font-medium text-white
             ${botonDeshabilitado ? 'cursor-not-allowed opacity-50' : ''}`}
            data-testid="show-status-button"
          >
            <div className="absolute inset-0 bg-gradient-to-t from-amber-400 to-amber-600 transition-transform duration-700 ease-in-out"></div>
            <div className="absolute inset-0 bg-gradient-to-b from-amber-400 to-amber-600 opacity-0 group-hover:opacity-100 transition-opacity duration-700 ease-in-out"></div>
            <span className="z-10 relative" data-testid="show-status-button-text">Verificar</span>
        </button>

        {showMessage && (
          <div className=" fixed inset-0 flex items-center justify-center z-50 mb-0 bg-black bg-opacity-80" data-testid="status-result-container">

            <div className="bg-white flex-row shadow-md rounded-lg shadow-amber-600/50 relative">
            <button onClick={handleClose} className="text-red-500 hover:text-red-800 absolute top-0 right-0 p-3"  data-testid="status-result-close-button">
                  <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                  </svg>
                </button>

                {
                state === "recibido" ? (
                    <div className="flex flex-col justify-between items-center p-12  mt-8">
                        <h2 className="text-2xl font-semibold mb-4" data-testid="status-result-title">Su estado es:</h2>
                        <h2 className={`text-2xl font-semibold mb-4 ${state === "recibido" ? "text-orange-600" : state === "aceptado" ? "text-green-600" : "text-red-600"}`}>
                            {state}
                        </h2>
                    </div>
                    ): (
                      <div className="p-6 pt-8">
                          <h4 className="text-lg font-semibold mt-4 text-pink-600" data-testid="status-result-title">Usted ya cuenta con un usuario</h4>
                      </div>
                )

                }

            {state === 'aceptado' && (
              <div className='p-4 pb-6 align-middle justify-center flex text-black hover:text-purple-700' > 
                <a href= {`/set-password?document=${documento}&roll=2`} >Crea tu contraseña aqui</a>
              </div>
            )}
            </div>
          </div>
        )}
          <ErrorModal
              isOpen={errorModalOpen}
              onClose={() => setErrorModalOpen(false)}
              message={modalMessage}
              data-testid="qr-generated-error-modal"
          />
      </div>
    );
}
export { ShowStatusButton }
